import { useEffect } from 'react'


const Questions = ({ question }) => {

    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")
        } catch (error) {
            
        }
    }

    useEffect(() => {
        LoadPage()
    }, [])

    
    return (
        <>
            {/* <header className="Screen__Questions">
                <p className="Screen__Questions__Header">Únete ingresando a WWW.ADSL.MX</p>
            </header>

            <section className="Screen__Questions Container-FullHeight">
                <div>
                    <img src="/img/brand/logotipo-adsl.png" className="LogoADSL Screen__Questions__Logo" alt="Logo" />
                    {question ? (
                        <p className="Screen__Questions__Text">{question.instruction}</p>
                    ) : (
                        <p className="Screen__Questions__Text">Cargando...</p>
                    )}
                </div>
            </section>
            
            <footer className='container'>
                <p className='text-center'>Hecho con ♥ por Interaktia | 2026</p>
            </footer> */}

            <div className='QuizzWithImageAndOptions__Screen__Background'>
                {/* {question?.isActiveWomensMode ? (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='FrontPage__Screen__Background__Image' />
                ) : (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Varonil-s2-1.png' className='FrontPage__Screen__Background__Image' />
                )} */}
                <img src='/img/games/quizz/laboratorios-tequis/background-3.png' className='FrontPage__Screen__Background__Image' />
            </div>

            <div className='Quizz__Screen Container-FullHeight' style={{ zIndex: '1' }}>
                <img src='/img/page/adsl-five.png' className='Quizz__Screen__Logo' />
                <p className='Quizz__Screen__Title'>{question.instruction}</p>

                <div className='Quizz__Screen__Container'>
                    <ul className='Quizz__Screen__Container__List'>
                        {question.options.map((option, index) => (
                            <li key={index} className='Quizz__Screen__Container__List__Item'>{option.text}</li>
                        ))}
                    </ul>
                </div>
            </div>

            <footer className='Quizz__Screen__Footer FooterCredits'>
                Hecho con ♥ por Interaktia | 2026
            </footer>
        </>
    )
}

export { Questions };